export function precoProduto (item) {
  var preco = parseFloat(item.ea015_pr_venda)
  return preco.toFixed(2).toString()
}
